module.exports = __webpack_public_path__ + "static/media/aiya-logo-blue.463d83b7.png";